<div *ngIf="!allProperties.length" class="place-self-center">
  <mat-spinner [diameter]="32"></mat-spinner>
</div>

<div
  *ngIf="allProperties.length"
  [ngClass]="(isMobile$ | async) ? 'justify-center text-center' : 'grid-cols-[1.3fr_1fr] gap-16 items-center'"
  class="grid items-center">
  <div>
    <ng-container *ngIf="!loading">
      <h2 class="m-0 mb-4">Showcase your property portfolio 🏘</h2>
      <p class="m-0 mb-6">
        We recommend creating one website (and one brand!) for all your properties. Alternatively, you can create
        multiple sites.
      </p>

      <mat-radio-group [(ngModel)]="properties">
        <mat-radio-button value="all">
          <span class="radio-button">
            <span fxLayoutAlign="start center" fxLayoutGap="6px"><span>List all my properties.</span></span>
          </span>
        </mat-radio-button>

        <mat-radio-button value="select">
          <span class="radio-button">
            <span fxLayoutAlign="start center" fxLayoutGap="6px">
              <span>List only the properties that I select on this site.</span>
            </span>
          </span>
        </mat-radio-button>
      </mat-radio-group>

      <div *ngIf="properties === 'select'">
        <sbnb-property-selection
          [allProperties]="false"
          [listHeight]="280"
          (propertiesChange)="propertyIds = $event.properties"></sbnb-property-selection>
      </div>

      <mat-error *ngIf="error">Something went wrong {{ error }}</mat-error>
    </ng-container>

    <ng-container *ngIf="loading">
      <h2 class="m-0 mb-4">We're creating your site</h2>
      <p class="m-0 mb-6">{{ loadingText }}</p>
    </ng-container>

    <sbnb-button
      class="block mt-6"
      [ngClass]="(isMobile$ | async) ? 'justify-self-center' : 'justify-self-start'"
      [loading]="loading"
      (click)="createSite()">
      Continue
    </sbnb-button>
  </div>

  <div *ngIf="!(isMobile$ | async)" class="grid place-content-center">
    <img class="max-h-[480px] w-auto max-w-[360px]" src="/assets/images/direct-site-creation/stage2.svg" />
  </div>
</div>
